import { useMemo } from "react";
import { EmptyState, ErrorState, Loading } from "../../components/States";
import { HubAnsicht } from "../agentur/hub/HubAnsicht";
import { useContracts, useCreatorBase } from "./data";
import { creatorHubKoops } from "./marken-hub";
import { DemoNote, useCreatorContext } from "./ui";
import { useT } from "./sprache";

/** Ohne Kampagnen (für Creator nicht lesbar), „Deals“ wie im übrigen Creator-Portal, Zeilen mit dem Titel des Deals */
const KARTEN = { ohneKampagnen: true, deals: true, ohneCreator: true } as const;

/**
 * Meine Marken (/creator/marken): der Hub der Agentur in der Sicht des Creators. Je Marke die eigenen Deals mit dem Stand von
 * Vertrag, Content und Rechnung, nur aus dem, was das Creator-Portal ohnehin lädt (Rechte über die Sichten talent_*).
 */
export function MeineMarken() {
  const { ws, scope, today, lang } = useCreatorContext();
  const t = useT();
  const base = useCreatorBase(scope);
  const vertraege = useContracts(scope);
  const koops = useMemo(() => (base.data ? creatorHubKoops(base.data, vertraege.data, today, lang) : []), [base.data, vertraege.data, today, lang]);
  if (base.error) return <ErrorState error={base.error} retry={() => void base.refetch()} />;
  if (base.isPending || vertraege.isPending) return <Loading />;
  return (
    <HubAnsicht
      koops={koops}
      blicke={["marke"]}
      kartenOptionen={KARTEN}
      klasse="tk-cr tk-cr-marken"
      eyebrow={t("Dein Creator-Portal", "Your creator portal")}
      titel={t("Meine Marken", "My brands")}
      text={t(`Deine Deals mit ${ws.org.name} je Marke, mit dem Stand von Vertrag, Content und Rechnung.`, `Your deals with ${ws.org.name} by brand, with the status of contract, content and invoice.`)}
      suchfeld={{ label: t("Marke oder Deal suchen", "Search brand or deal"), platzhalter: t("Marke, Deal …", "Brand, deal …") }}
      hinweis={t("Klick auf eine Zeile öffnet den Deal, Klick auf den Vertrag direkt den Vertrag.", "Click a row to open the deal, click the contract to go straight to the contract.")}
      leer={<EmptyState title={t("Noch keine Deals.", "No deals yet.")} text={t("Sobald deine Agentur einen Deal mit einer Marke für dich anlegt, siehst du hier, wie es um Vertrag, Content und Rechnung steht.", "As soon as your agency creates a deal with a brand for you, you will see the status of contract, content and invoice here.")} />}
      fuss={<DemoNote />}
    />
  );
}
